import React from 'react';
import Slider from 'react-slick';
import './index.scss';

import Img from 'gatsby-image';
import { getFluidGatsbyImage } from 'gatsby-source-sanity';
import clientConfig from '../../../client-config';

export default function HeroImageSlider({ sliderImages }) {
  function SampleNextArrow({ className, style, onClick }) {
    return <div className={className} onClick={onClick} role="button" />;
  }

  function SamplePrevArrow({ className, style, onClick }) {
    return <div className={className} onClick={onClick} role="button" />;
  }

  const settings = {
    lazyLoad: true,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 4000,
    nextArrow: <SampleNextArrow className="slick-prev" />,
    prevArrow: <SamplePrevArrow className="slick-next" />,
  };

  return (
    <div className="slider-container">
      <div className="container">
        <Slider {...settings}>
          {sliderImages.map((img) => {
            return (
              <div className="slide-wrap" key={Math.random().toString(36).substring(7)}>
                <Img fluid={getFluidGatsbyImage(img.imgPath, { maxWidth: 675 }, clientConfig.sanity)} alt={img.imgAltText} />
                <p className="img-caption">{img.imgCaption}</p>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
}
